export default "__VITE_ASSET__$YMjxGZd__"